import { DriveView } from './drive/components/DriveView'
import { useUserFilesPollingProcessor } from './polling/hooks/useUserFilesPollingProcessor'

/**
 * UserFilesPage
 *
 * Main page for the user files feature, housing the folder browser (DriveView)
 * and all folder management functionality.
 */
export default function UserFilesPage() {
  useUserFilesPollingProcessor()

  return <DriveView />
}
